const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const AdminAnalyticsActions = Reflux.createActions({
    getAdminOverviewStatsRange: { children: ['completed', 'failed'] },
    getAdminActInstTemplateRange: { children: ['completed', 'failed'] },
    getAdminOverviewUsersRange: { children: ['completed', 'failed'] },
    getAdminActInstRawDataWithError: { children: ['completed', 'failed'] },
    getAdminActInstAnalytics: { children: ['completed', 'failed'] },
    retryAdminActInstAnalytics: { children: ['completed', 'failed'] },
});

// Admin overview stats.
AdminAnalyticsActions.getAdminOverviewStatsRange.listen(function(actionId, params) {
    const self = this;
    if (!params.startDate || !params.endDate) {
        this.failed(actionId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeRequest('/authoring/overview_stats_range', 'POST', JSON.stringify({
            start_date: params.startDate.format('YYYY-MM-DD'),
            end_date: params.endDate.format('YYYY-MM-DD')
        }))
        .then(res => { self.completed(actionId, res); })
        .catch(err => { self.failed(actionId, err); });
});

// Admin overview act inst created per-template.
AdminAnalyticsActions.getAdminActInstTemplateRange.listen(function(actionId, params,manager) {
    const self = this;
    if (!params.startDate || !params.endDate) {
        this.failed(actionId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makePollTaskRequest('/authoring/overview_act_inst_template_range', 'POST', JSON.stringify({
            start_date: params.startDate.format('YYYY-MM-DD'),
            end_date: params.endDate.format('YYYY-MM-DD')
        }),manager, actionId)
        .then(res => self.completed(actionId, res))
        .catch(err =>self.failed(actionId, err));
});


// Admin overview users stats.
AdminAnalyticsActions.getAdminOverviewUsersRange.listen(function(actionId, params, manager) {
    const self = this;
    if (!params.startDate || !params.endDate) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makePollTaskRequest('/authoring/overview_users_range', 'POST', JSON.stringify({
            start_date: params.startDate.format('YYYY-MM-DD'),
            end_date: params.endDate.format('YYYY-MM-DD')
        }),manager)
        .then(res => { self.completed(actionId, res); })
        .catch(err => { self.failed(actionId, err); });
});

AdminAnalyticsActions.getAdminActInstRawDataWithError.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest('/authoring/analytics/raw_data/error', 'GET')
    .then(res => self.completed(actionId, res))
    .catch(err => self.failed(actionId, err));
});

AdminAnalyticsActions.getAdminActInstAnalytics.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/analytics/activity_instance/${params.novaActInstId}`, 'GET')
    .then(res => self.completed(actionId, params.novaActInstId, res))
    .catch(err => self.failed(actionId, params.novaActInstId, err));
});

AdminAnalyticsActions.retryAdminActInstAnalytics.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/analytics/activity_instance/${params.novaActInstId}`, 'PATCH')
    .then(res => self.completed(actionId, params.novaActInstId, res))
    .catch(err => self.failed(actionId, params.novaActInstId, err));
});

module.exports = AdminAnalyticsActions;
